import React, {
    ReactElement,
    Suspense,
    useCallback,
    useContext,
    useEffect,
    useLayoutEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import AppSidebarV2, {
    IAppSidebar,
    IAppSidebarInnerRef,

    // IMenuItems,
} from 'shared/components/AppSidebarV2';
import { Outlet, useLocation } from 'react-router';
import { Box, Typography } from '@mui/material';
import { DefaultSidebar } from 'shared/hooks/Layout';
import { connect, useSelector, useDispatch } from 'react-redux';
import { UserSettingService } from 'services/UserSettingService';
import CircularProgress from '@mui/material/CircularProgress';
import store from 'state/RootReducer';
import { ProfileActions } from 'state/profile/Action';
import { Toast, Utils } from 'shared/helpers';

import { ProfileState } from 'state/profile/Reducer';
import { AuthState } from 'state/authentication/Reducer';
import { SocketService } from 'services/SocketService';
import { SocketActions } from 'state/socket/Action';
import { AuthActions } from 'state/authentication/Action';
import {
    clearRefreshInterval,
    renewAccessToken,
} from 'shared/helpers/IdleCheck';
import {
    resetSidebarDashboardTheme,
    setSidebarDashboard,
    setSidebarFetchTemplate,
} from 'state/baseapplication/Action';
import { BroadcastActions } from 'state/broadcast/Action';

import { CarryAppActions } from 'state/carriesapplication/Action';

import uniqid from 'uniqid';
import { PersistAppActions } from 'state/persistapplication/Action';
import {
    useEvent,
    useHarmonicIntervalFn,
    useNetworkState,
    usePageLeave,
    useTimeoutFn,
    useUpdateEffect,
} from 'react-use';
import { AuthenticationService } from 'services';

import { refreshAccessToken } from 'shared/manager/AxiosManager';
import { useDebouncedCallback } from 'use-debounce';
import useIdleHook from './useIdleHook';
import { useLeavePrompt } from 'shared/helpers/UseExitPrompt';
import jwt_decode from 'jwt-decode';
import { BrowserMeta } from 'BrowserHistory';
import { AxiosError } from 'axios';

const SuspenseTrigger = (): ReactElement => {
    throw new Promise(() => {});
};

/**
 * Renders the Layout component.
 * @returns {ReactElement} The rendered component.
 */
const Layout = (props: any): ReactElement => {
    const role = useSelector((state: any) => state.authState.role);
    const refreshTokenIn = useSelector(
        (state: any) => state.authState.refreshTokenIn
    );
    const globalDashboardTemplateId = useSelector(
        (state: any) => state.profileState.userInfo.globalDashboardTemplateId
    );
    const globalTemplateEnabled = useSelector(
        (state: any) =>
            state.profileState.userInfo.globalDashboardTemplateEnabled
    );
    const customTemplateEnabled = useSelector(
        (state: any) =>
            state.profileState.userInfo.customDashboardTemplateEnabled
    );

    const customDashboardTemplateId = useSelector(
        (state: any) => state.profileState.userInfo.customDashboardTemplateId
    );

    // const isChunkLoaded = useSelector(
    //     (state: any) => state.carryState.isChunkLoaded
    // );

    const broadcastPageLeave = useSelector(
        (state: any) => state.broadcastState.broadcastPageLeave
    );

    const broadcastAuthState = useSelector(
        (state: any) => state.broadcastState.broadcastAuthState
    );
    const router = useSelector((state: any) => state.router);
    const [sideMenus, setSideMenus] = useState<any[]>([]);
    const dispatch = useDispatch();
    const {
        profileState,
        authState,
    }: { profileState: ProfileState; authState: AuthState } = props;
    const { isExpiritySession, isIdleCheckLogout, ExpritySessionMsg } =
        authState;
    const location = useLocation();
    const fullwidthPage = [
        'reviewer-viewer',
        'single-reviewed',
        'upload-rework',
        'finish-upload-rework',
    ];
    const [isProfileLoaded, setProfileLoaded] = useState<boolean>(false);
    const [isProfileRetry, setProfileRetry] = useState<boolean>(false);
    const [isNetworkError, setNetworkError] = useState<boolean>(false);

    const tabId = useSelector((state: any) => state.carryState.tabId);
    const persistTabId = useSelector((state: any) => state.persistState.tabId);

    const persistDocumentTabId = useMemo(() => persistTabId, []);
    const isDocumentReload = useMemo(
        () => persistTabId !== persistDocumentTabId,
        [persistTabId]
    );

    const browserProps = useContext(BrowserMeta);

    useEffect(() => {
        browserProps?.setDocumentReload(isDocumentReload);
    }, [isDocumentReload]);
    const [refreshTabId, setRefreshTabId] = useState<boolean>(false);
    useEffect(() => {
        if (typeof Storage !== 'undefined' && tabId === '') {
            const newertabId = uniqid();
            dispatch(CarryAppActions.SetBroadcastTabId(newertabId));
            setRefreshTabId(true);
        }
    }, [tabId]);

    const [isPageLeave, setPageLeave] = useState<boolean>(false);
    const [isTriggerPageLeave, setTriggerPageLeave] = useState<boolean>(false);
    const [isTriggerRecordTabActive, setRecordTabActive] =
        useState<boolean>(false);
    const handleVisibilityChange = useCallback(() => {
        setPageLeave(document.visibilityState === 'hidden');
        setTriggerPageLeave(true);
        setRecordTabActive(document.visibilityState === 'visible');
    }, []);

    const isTriggerPageDelay = useMemo(
        () => (isPageLeave === false ? 200 : 0),
        [isPageLeave]
    );
    const [isBroadcastedPageLeave, setBroadcastedPageLeave] =
        useState<boolean>(false);
    const [isBroadcastedPageLeaveCheck, setBroadcastedPageLeaveCheck] =
        useState<boolean>(false);
    useEffect(() => {
        if (isProfileLoaded === false) {
            if (broadcastPageLeave) {
                setBroadcastedPageLeave(true);
            } else if (
                broadcastPageLeave === false &&
                isBroadcastedPageLeave === true
            ) {
                setBroadcastedPageLeaveCheck(true);
                setBroadcastedPageLeave(false);
            }
        }
    }, [broadcastPageLeave]);

    useEffect(() => {
        if (isBroadcastedPageLeaveCheck) {
            if (
                broadcastAuthState &&
                broadcastAuthState.accessToken !== authState.accessToken &&
                broadcastAuthState.email &&
                authState.email &&
                broadcastAuthState.email.id === authState.email.id
            ) {
                dispatch(
                    AuthActions.updateLoginStatus({ ...broadcastAuthState })
                );
            }
            setBroadcastedPageLeaveCheck(false);
            setBroadcastedPageLeave(false);
        }
    }, [isBroadcastedPageLeaveCheck, isBroadcastedPageLeave]);

    useLayoutEffect(() => {
        if (isPageLeave === false) {
            dispatch(BroadcastActions.SetBroadcastPageLeave(false));
        }
    }, []);
    useHarmonicIntervalFn(
        () => {
            dispatch(BroadcastActions.SetBroadcastPageLeave(isPageLeave));
            dispatch(
                BroadcastActions.setBroadcastAuthData({
                    accessToken: authState.accessToken,
                    refreshToken: authState.refreshToken,
                    email: authState.email,
                })
            );
            if (isTriggerPageLeave) {
                setTriggerPageLeave(false);
            }
        },
        isTriggerPageLeave === true ? isTriggerPageDelay : null
    );

    useEffect(() => {
        if (isTriggerRecordTabActive) {
            dispatch(BroadcastActions.setBroadcastActiveTab(tabId));
            setRecordTabActive(false);
        }
    }, [isTriggerRecordTabActive]);

    useEvent('visibilitychange', handleVisibilityChange);
    useLayoutEffect(() => {
        if (refreshTabId && tabId !== '') {
            dispatch(PersistAppActions.SetRouteTabId(tabId));
            setRefreshTabId(false);
        }
    }, [refreshTabId]);

    const handleLoadProfileData = React.useCallback((): void => {
        UserSettingService.getProfile()
            .then((response: any) => {
                const { data } = response.data;
                if (data.userInfo) {
                    if (
                        data.userInfo.globalDashboardTemplateId !==
                            globalDashboardTemplateId ||
                        (data.userInfo.globalDashboardTemplateEnabled !==
                            globalTemplateEnabled &&
                            globalTemplateEnabled === true)
                    ) {
                        dispatch(
                            setSidebarDashboard({
                                reduxInitValues: {},
                            })
                        );
                        dispatch(setSidebarFetchTemplate(false));
                        dispatch(resetSidebarDashboardTheme(true));
                    } else if (
                        data.userInfo.customDashboardTemplateId !==
                            customDashboardTemplateId ||
                        (data.userInfo.customDashboardTemplateEnabled !==
                            customTemplateEnabled &&
                            customTemplateEnabled === true)
                    ) {
                        dispatch(
                            setSidebarDashboard({
                                reduxInitValues: {},
                            })
                        );
                        dispatch(setSidebarFetchTemplate(false));
                        dispatch(resetSidebarDashboardTheme(true));
                    }
                }
                store.dispatch(
                    ProfileActions.setProfileData({
                        ...data,
                        userInfo: {
                            ...data.userInfo,
                            email: data.userInfo.email.id,
                        },
                    })
                );
                setProfileLoaded(true);
            })
            .catch((error: any) => {
                setProfileRetry(true);

                setProfileLoaded(false);
                if (
                    error !== null &&
                    error instanceof AxiosError &&
                    error.code === 'ERR_NETWORK'
                ) {
                    setNetworkError(true);
                } else {
                    Utils.handleErrorResponse(error);
                }
            });
    }, [
        customDashboardTemplateId,
        customTemplateEnabled,
        dispatch,
        globalDashboardTemplateId,
        globalTemplateEnabled,
    ]);
    const [isSocket, setSocketActivity] = useState<boolean>(false);
    const [isSocketPending, setSocketPending] = useState<boolean>(false);
    const [isSocketRetry, setSocketRetry] = useState<boolean>(false);
    const [retrySocket, setRetrySocket] = useState<number>(0);
    const [retrySasSocket, setRetrySasSocket] = useState<number>(0);
    const [timeToRefresh, setTimeToRefresh] = useState<number>(0);
    const [isTimelySocket, setTimelySocket] = useState<boolean>(false);
    const handleSocketRefreshTimeout = React.useCallback(() => {
        if (timeToRefresh > 0 && (isSocket || isSocketPending)) {
            setRetrySocket(0);
            setSocketActivity(false);
            setSocketPending(false);
            setRetrySasSocket(0);
        }
    }, [isSocket, timeToRefresh]);
    const [isReady, cancel, reset] = useTimeoutFn(
        handleSocketRefreshTimeout,
        timeToRefresh
    );
    const { online, previous } = useNetworkState();
    useLayoutEffect(() => {
        if (timeToRefresh > 0 && isTimelySocket) {
            const readiesTime = isReady();
            if (typeof readiesTime === 'boolean') {
                cancel();
                reset();
            } else {
                reset();
            }
            setTimelySocket(false);
        }
    }, [isTimelySocket, timeToRefresh]);
    React.useLayoutEffect(() => {
        if (
            isSocket === false &&
            isSocketPending === false &&
            isSocketRetry === false &&
            retrySocket < 2
        ) {
            setRetrySocket((prev) => prev + 1);
            const readiesTime = isReady();
            if (typeof readiesTime === 'boolean') {
                cancel();
            }
            SocketService.getSocketToken()
                .then((response) => {
                    const { data } = response;
                    const {
                        data: { url },
                    } = data;
                    const accessToken = url
                        .split('packetstatus?access_token=')
                        .pop();
                    const decoded: any = jwt_decode(accessToken);
                    const { exp } = decoded;

                    const currentTime = new Date().getTime();
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const timeToExpire = exp * 1000 - currentTime;

                    setTimeToRefresh(timeToExpire);
                    setTimelySocket(true);
                    console.log('------SocketService: Initialize');
                    dispatch(SocketActions.SetSocketActivity(true));
                    dispatch(SocketActions.SetSocketInitialHandshake(url));
                    setSocketActivity(true);
                    setSocketRetry(false);
                })
                .catch((error) => {
                    console.log('------SocketService: Init Error');
                    Utils.handleErrorResponse(error);
                    setSocketActivity(false);
                    setSocketRetry(true);
                });
        }
    }, [isSocket, isSocketPending]);
    useUpdateEffect(() => {
        if (
            isSocket === false &&
            isSocketPending === false &&
            isSocketRetry === false
        ) {
            const readiesTime = isReady();
            if (typeof readiesTime === 'boolean') {
                cancel();
            }
            SocketService.getSocketToken()
                .then((response) => {
                    const { data } = response;
                    const {
                        data: { url },
                    } = data;
                    const accessToken = url
                        .split('packetstatus?access_token=')
                        .pop();
                    const decoded: any = jwt_decode(accessToken);
                    const { exp } = decoded;

                    const currentTime = new Date().getTime();
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const timeToExpire = exp * 1000 - currentTime;

                    setTimeToRefresh(timeToExpire);
                    setTimelySocket(true);
                    console.log('------SocketService: Initialize');
                    dispatch(SocketActions.SetSocketActivity(true));
                    dispatch(SocketActions.SetSocketInitialHandshake(url));
                    setSocketActivity(true);
                    setSocketRetry(false);
                })
                .catch((error) => {
                    console.log('------SocketService: Init Error');
                    Utils.handleErrorResponse(error);
                    setSocketActivity(false);
                    setSocketRetry(true);
                });
        }
    }, [isSocketRetry]);
    useUpdateEffect(() => {
        if (isSocketRetry) {
            setRetrySasSocket((prev) => prev + 1);
            if (retrySasSocket < 3) {
                setSocketRetry(false);
            }
        }
    }, [isSocketRetry]);
    useUpdateEffect(() => {
        if (previous === false && online && retrySocket) {
            setRetrySasSocket(0);
            setRetrySocket(0);
            setSocketRetry(false);
        }
    }, [online, previous]);
    const socketActive = useSelector((state: any) => state.socketState.active);
    useUpdateEffect(() => {
        if (isSocket && socketActive === false) {
            setSocketActivity(false);
            if (retrySocket > 1) {
                setSocketPending(true);
            }
        }
    }, [socketActive]);

    const buildSideMenus = React.useCallback((): void => {
        let menus = DefaultSidebar;
        if (role === 'operator' || role === 'senior') {
            menus = menus.filter((i) => i.path !== '/manage-checklists');
        }
        if (role === 'operator') {
            menus = menus.filter((i) => i.path !== '/manage-access');
        }

        setSideMenus(menus);
    }, [role]);
    const [isUserDetailChange, setUserDetailChanges] =
        React.useState<boolean>(false);
    const [isMenuChanged, setMenuChanged] = React.useState<boolean>(false);
    const locationName = React.useMemo(
        () =>
            router.location &&
            router.location.pathname &&
            Array.isArray(router.previousLocations) &&
            router.previousLocations.length > 1
                ? router.location.pathname
                : null,
        [isMenuChanged, isUserDetailChange]
    );

    useEffect(() => {
        if (isMenuChanged) {
            setMenuChanged(false);
        }
    }, [isMenuChanged]);

    useEffect(() => {
        if (isUserDetailChange) {
            setUserDetailChanges(false);
        }
    }, [isUserDetailChange]);

    useUpdateEffect(() => {
        if (locationName === '/dashboard' && isProfileRetry === false) {
            handleLoadProfileData();
        }
    }, [locationName]);

    useUpdateEffect(() => {
        if (isProfileRetry && browserProps?.isDocumentReload === false) {
            setProfileRetry(false);
            setNetworkError(false);
            handleLoadProfileData();
        }
    }, [isMenuChanged, isUserDetailChange]);

    useEffect(() => {
        dispatch(BroadcastActions.SetBroadcastInitialHandshake(true));
    }, []);

    useLayoutEffect(() => {
        if (location.pathname && tabId !== '') {
            dispatch(
                BroadcastActions.SetBroadcastReduxMessage({
                    ...location,
                    tabId,
                    parentTabId: persistTabId,
                })
            );
            dispatch(
                BroadcastActions.SetBroadcastReduxDraft({
                    ...location,
                    tabId,
                    parentTabId: persistTabId,
                })
            );
        }
    }, [location.pathname, tabId]);

    useEffect(() => {
        if (location.pathname !== '/user/details') {
            handleLoadProfileData();
        }
        buildSideMenus();
    }, [role]);

    const [isInitializeSideMenu, setInitializeSideMenu] =
        useState<boolean>(false);

    useEffect(() => {
        if (
            location.pathname === '/user/details' &&
            profileState &&
            profileState.userInfo &&
            // eslint-disable-next-line no-underscore-dangle
            (profileState.userInfo.userId || profileState.userInfo._id)
        ) {
            setProfileLoaded(true);
            setInitializeSideMenu(true);
        }
    }, [role, profileState]);

    /**
     * The navigation function used to navigate to different routes.
     * @type {Function}
     */
    // const navigate = useNavigate();

    /**
     * Retrieves the sidebar configuration from the Redux state.
     * @param {any} state - The Redux state object.
     * @returns {any[]} The sidebar configuration.
     */

    /**
     * Function called when the menu changes.
     * @param {string} ev - The event value.
     * @returns {void}
     */

    /**
     * Props for the AppSidebarV2 component.
     * @type {IAppSidebar}
     */
    const sidebarInnerRef = useRef<IAppSidebarInnerRef | null>(null);
    const [appSidebarProps, setappSidebarProps] = useState<IAppSidebar>({
        ref: sidebarInnerRef,
        children: <Box />,
        menus: sideMenus,
        // profileState,
        defaultLogo: '/images/brand/thumblogo.png',
        defaultLogoLink: '/dashboard',
        // logoutUser: () =>
        //     // payload: any
        //     {},
        onUserDetailClick: () => {
            setUserDetailChanges(true);
        },
        onMenuChange: (menu) =>
            // menu: IMenuItems
            {
                if (
                    menu.path === '/dashboard' &&
                    location.pathname !== menu.path
                ) {
                    setProfileLoaded(false);
                }
                setMenuChanged(true);
            },
    });

    useLayoutEffect(() => {
        setappSidebarProps((prev) => ({
            ...prev,
            profileState,
            // menus: DefaultSidebar.filter(
            //     (i) =>
            //         role !== 'operator' ||
            //         (role === 'operator' && i.path !== '/manage-clients')
            // ).filter(
            //     (i: any) =>
            //         (i.path === '/manage-access' && role === 'clientManager') ||
            //         i.path !== '/manage-access' ||
            //         role === ''
            // ),
            menus: sideMenus,
        }));
    }, [profileState, role, isInitializeSideMenu]);

    const doPortalLogout = (): void => {
        console.log('------IdleCheck: Layout file doPortalLogout');
        AuthenticationService.logout({ idleCheck: true })
            .then(() => {})
            .catch(() => {})
            .finally(() => {
                console.log('------IdleCheck: Layout file clearing state');
                dispatch(AuthActions.doLogout({}));
            });
    };

    const [idleState, setIdleState] = useState('no');

    const onUserIdle = (): void => {
        console.log('----onUserIdle');
        setIdleState('yes');
    };

    useIdleHook({
        onIdle: onUserIdle,
        timeout: 30 * 60 * 1000,
    });

    useEffect(() => {
        if (idleState === 'yes') {
            console.log('------useEffect onIdle');
            doPortalLogout();
            const translateExprityMsg = 'Your session has expired';
            Toast.showErrorMessage(translateExprityMsg);
        }
    }, [idleState]);

    useEffect(() => {
        renewAccessToken();
        return () => {
            console.log('----unmount component calling clear');
            clearRefreshInterval();
        };
    }, []);

    const [isLoggingOutToast, setLoggingOutToast] = useState<boolean>(false);
    useEffect(() => {
        if (ExpritySessionMsg && (isExpiritySession || isIdleCheckLogout)) {
            const translateExprityMsg =
                ExpritySessionMsg === 'Token session expired'
                    ? 'Your session has expired'
                    : ExpritySessionMsg;
            if (isIdleCheckLogout) {
                setLoggingOutToast(true);
            }
            Toast.showErrorMessage(translateExprityMsg);
        }
    }, [isExpiritySession, ExpritySessionMsg, isIdleCheckLogout]);

    useEffect(() => {
        console.log(
            '------IdleCheck: Layout file isIdleCheckLogout ',
            isIdleCheckLogout
        );
        if (isIdleCheckLogout && isLoggingOutToast) {
            console.log('------IdleCheck: Layout file doPortalLogout');
            doPortalLogout();
        }
    }, [isIdleCheckLogout, isLoggingOutToast]);

    const debouncedRefreshToken = useDebouncedCallback(
        // function
        () => {
            console.log('------IdleCheck: Going to renew');
            refreshAccessToken()
                .then(() => {
                    console.log('------IdleCheck: Token renewed');
                    renewAccessToken();
                })
                .catch(() => {})
                .finally(() => {
                    localStorage.removeItem('isTokenRefreshing');
                });
        },
        // delay in ms
        2000
    );

    useEffect(() => {
        const isTokenRefreshing = localStorage.getItem('isTokenRefreshing');
        console.log('isTokenRefreshing', isTokenRefreshing);
        if (refreshTokenIn !== 0 && !isTokenRefreshing) {
            localStorage.setItem('isTokenRefreshing', 'yes');
            debouncedRefreshToken();
        }
    }, [refreshTokenIn]);

    const callbackForPromptAlert = React.useCallback(() => {}, []);
    const [, showLeavePrompt] = useLeavePrompt(false, callbackForPromptAlert);
    useEffect(() => {
        if (
            window.history.state &&
            window.history.state.idx === 0 &&
            [
                '/reviewer-viewer',
                '/not-expected-cross-check',
                '/single-cross-check',
            ].includes(location.pathname) === false
        ) {
            showLeavePrompt(true);
        } else {
            showLeavePrompt(false);
        }
    }, [location.pathname]);

    const persistIdx = useSelector((state: any) => state.persistState.idx);

    useLayoutEffect(() => {
        if (window.history.state && persistIdx !== window.history.state.idx) {
            dispatch(PersistAppActions.SetAppPreviouslyIdx(persistIdx));
            dispatch(
                PersistAppActions.SetAppIdx(
                    window.history.state && window.history.state.idx
                        ? window.history.state.idx
                        : null
                )
            );
        }
    }, [location.pathname, router]);

    const [isPointMainContainer, setPointMainContainer] =
        useState<boolean>(false);
    useEvent('mouseover', () => {
        setPointMainContainer(false);
    });

    usePageLeave(() => {
        setPointMainContainer(true);
    });
    useEffect(() => {
        dispatch(CarryAppActions.setPageLeave(isPointMainContainer));
    }, [isPointMainContainer]);

    return (
        <Box className="app-container">
            {fullwidthPage.includes(
                location.pathname.replace('/', '').replace(/\/(.*)/i, '')
            ) === false && (
                <Box className="app-left-container">
                    <AppSidebarV2 {...appSidebarProps} />
                </Box>
            )}

            <Box className="app-right-container">
                <Suspense
                    fallback={
                        <Box className="align-loader">
                            {isNetworkError ? (
                                <Box className="mr-2 margin-loader">
                                    <Typography variant="h3">
                                        No internet connection, Please try
                                        again!
                                    </Typography>
                                </Box>
                            ) : (
                                <CircularProgress
                                    title="progress loading"
                                    className="mr-2 margin-loader"
                                    size={54}
                                    color="inherit"
                                />
                            )}
                        </Box>
                    }
                >
                    {isProfileLoaded ? <Outlet /> : <SuspenseTrigger />}
                </Suspense>
            </Box>
        </Box>
    );
};
const mapStateToProps = (state: any): any => ({
    profileState: state.profileState,
    authState: state.authState,
});

export default connect(mapStateToProps, null)(Layout);
